import List from "../list"
import { DropShipSource } from "helper/constant";

const DropShippingList = () => {

    return (
        <List source={DropShipSource.Sellvity} />
    );
};


export default DropShippingList;
